// removed by extract-text-webpack-plugin
module.exports = {"MazeResult":"MazeResult-cssmodule-MazeResult-2x9pj"};


//////////////////
// WEBPACK FOOTER
// ./components/ModalSet/MazeResult.cssmodule.less
// module id = 661
// module chunks = 0